import { useSyncExternalStore } from "react";
import { useRowSelectionContext } from "../context/RowSelectionContext";
import { useDataTableSettings } from "./useDataTableSettings";

/**
 * Returns the full row data (row.original) for all currently selected rows.
 */
export function useSelectedTableRows<T extends { id: string }>(): T[] {
  const { store } = useRowSelectionContext();
  const settings = useDataTableSettings<T>();

  useSyncExternalStore(
    store.subscribe,
    () => store.getSelectionCount(),
    () => 0,
  );

  const table = settings?.table;
  if (!table) return [];

  const selection = store.getSelection();
  return table
    .getRowModel()
    .rows.filter((row) => selection.has(row.id))
    .map((row) => row.original);
}
